import { confirm } from '../../../lib/bootbox'

export async function promptToConfirmAddingNewPaidUser(action: string = 'Save'): Promise<boolean> {
  return confirm({
    title: 'You have added a new paid user',
    message:
      'We have noticed you have added a new paid user. We are charging every user with edit and admin role. Do you really want to continue?',
    buttons: {
      confirm: {
        label: `Confirm & ${action}`,
        className: 'btn-positive'
      },
      cancel: {
        label: 'Back'
      }
    }
  })
}
